var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramSuperannuation40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/ExtraSmall./Superannuation40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Superannuation",
    transform: "translate(6.000000, 6.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8333333,13.9166667 C21.8333333,9.4639358 18.2860642,5.91666667 13.8333333,5.91666667 C9.38060247,5.91666667 5.83333333,9.4639358 5.83333333,13.9166667 C5.83333333,18.3482203 9.41918672,21.9166667 13.8333333,21.9166667 C18.2474799,21.9166667 21.8333333,18.3482203 21.8333333,13.9166667 Z",
    id: "Focus",
    fill: "#FFCC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "square",
    transform: "translate(0.833333, 0.916667)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.4,
    y1: 3.5,
    x2: 20.5333333,
    y2: 5.36666667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.33333333,
    y1: 13.0666667,
    x2: -6.06403816e-13,
    y2: 13.0666667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.6666667,
    y1: 13.0666667,
    x2: 23.3333333,
    y2: 13.0666667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.4,
    y1: 22.6333333,
    x2: 20.5333333,
    y2: 20.7666667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.26666667,
    y1: 22.6333333,
    x2: 5.13333333,
    y2: 20.7666667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.26666667,
    y1: 3.5,
    x2: 5.13333333,
    y2: 5.36666667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8333333,
    y1: 26.1333333,
    x2: 12.8333333,
    y2: 23.8,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8333333,
    y1: 2.33333333,
    x2: 12.8333333,
    y2: -9.54791801e-15,
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramSuperannuation40);
export default __webpack_public_path__ + "static/media/pictogramSuperannuation40.31fb102bced9abadf12d58fc0718a6e8.svg";
export { ForwardRef as ReactComponent };